<template>
	<div class="removeButton">
		<p-button
			:disabled="disabled"
			@click="onRemove"
			type="danger"
			outline
			size="sm"
			class="float-right">
			<i class="fa fa-times"></i><span>{{ this.buttonText }}</span>
		</p-button>



		<DeleteModal
			:itemid="this.itemid"
			:modalid="modalid"
            :message="confirmmsg"
			id="deleteModalcomp"
			@ok="this.removeConfirmed"
			@cancel="this.removeCanceled"
			ref="confirmModal">
		</DeleteModal>
	</div>
</template>

<script>
import DeleteModal from "@/components/Misc/DeleteModal";

export default {
	name: "RemoveButton",
	props: {
		itemid: { type: String },
		modalid: { type: String },
		confirmmsg: { type: String },
		buttontxt: { type: String, default: "notdefined" },
		disabled: { type: Boolean, default: false },
	},
	components: {
		DeleteModal,
	},
	data: function () {
		return {
			confirmOpen: false,
		};
	},
	computed: {
		buttonText: function () {
			if (this.buttontxt == "notdefined") {
				return this.$t("button.remove");
			} else {
				return this.buttontxt;
			}
		},
	},
	methods: {
		onRemove: function () {
			this.confirmOpen = true;
			this.$refs.confirmModal.show();
		},
		removeConfirmed() {
			this.confirmOpen = false;
			this.$emit("remove");
		},
		removeCanceled() {
			this.confirmOpen = false;
			this.$emit("cancel");
		},
		test(){
			alert("test");
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
i.fa.fa-times {
	/* padding-right: .3em; */
}
div.removeButton {
	display: inline;
}
</style>
